<script setup lang="ts">
import type { PopoverContentEmits, PopoverContentProps } from "reka-ui";
import { useIsUsingKeyboard } from "ls/composables/useIsUsingKeyboard";
import { PopoverContent, useForwardPropsEmits } from "reka-ui";
import MenuContent from "../primitives/menu/MenuContent.vue";

const props = defineProps<PopoverContentProps & { menu?: boolean }>();
const emits = defineEmits<PopoverContentEmits>();
const forwarded = useForwardPropsEmits(props, emits);

const { isUsingKeyboard } = useIsUsingKeyboard();
function handleCloseAutoFocus(event: Event) {
  if (!isUsingKeyboard.value) {
    event.preventDefault();
  }
}
</script>

<template>
  <PopoverContent
    v-bind="forwarded"
    :collision-padding="10"
    :side-offset="props.sideOffset ?? 2"
    as-child
    class="max-h-(--reka-popover-content-available-height) max-w-(--reka-popover-content-available-width) min-w-(--reka-popover-trigger-width) origin-(--reka-popover-content-transform-origin)
    transform-gpu
    data-[state=closed]:animate-menu-out
    data-[state=open]:animate-menu-in
    "
    @close-auto-focus="handleCloseAutoFocus"
  >
    <MenuContent :variant="menu ? 'grid' : 'column'">
      <slot />
    </MenuContent>
  </PopoverContent>
</template>
